module.exports = __webpack_public_path__ + "static/media/swingBottomImg1.7ad7c0f5.png";